import React from "react";
import {
  UilTemperature,
  UilTear,
  UilWind,
  UilSun,
  UilSunset,
} from "@iconscout/react-unicons";
import { iconUrlFromCode, localTime } from "../Utils/WeatherApi";

function Details({
  weather: {
    details,
    icon,
    temp,
    temp_min,
    temp_max,
    sunrise,
    sunset,
    speed,
    humidity,
    feels_like,
    timezone,
  },
}) {
  return (
    <div>
      <div className="flex flex-col items-center justify-center py-6 text-xl text-cyan-300">
        <p>{details}</p>
        <img src={iconUrlFromCode(icon)} alt="" className="w-20" />
      </div>

      <div className="flex flex-row items-center justify-around text-white py-3">
        <p className="text-5xl">{temp.toFixed()}°</p>
        <div className="flex flex-col space-y-2">
          <div className="flex font-light text-sm items-center justify-start">
            <UilTemperature size={18} className="mr-1" />
            Feels like:
            <span className="font-medium ml-1">{feels_like.toFixed()}°</span>
          </div>
          <div className="flex font-light text-sm items-center justify-start">
            <UilTear size={18} className="mr-1" />
            Humidity:
            <span className="font-medium ml-1">{humidity.toFixed()}%</span>
          </div>
          <div className="flex font-light text-sm items-center justify-start">
            <UilWind size={18} className="mr-1" />
            Wind:
            <span className="font-medium ml-1">{speed.toFixed()} MPH</span>
          </div>
          <div className="flex font-light text-sm items-center justify-start">
            <UilSun />
            <p className="font-light">
              High:
              <span className="font-medium ml-1">{temp_max.toFixed()}°</span>
            </p>
          </div>
          <div className="flex font-light text-sm items-center justify-start">
            <UilSun />
            <p className="font-light">
              Low:
              <span className="font-medium ml-1">{temp_min.toFixed()}°</span>
            </p>
          </div>
        </div>
      </div>

      <div className="flex flex-row items-center justify-center space-x-2 text-white text-sm py-3">
        <UilSun />
        <p className="font-light">
          Rise:
          <span className="font-medium ml-1">
            {localTime(sunrise, timezone, "hh:mm a")}
          </span>
        </p>
        <p className="font-light">|</p>
        <UilSunset />
        <p className="font-light">
          Rise:
          <span className="font-medium ml-1">
            {localTime(sunset, timezone, "hh:mm a")}
          </span>
        </p>
      </div>
    </div>
  );
}

export default Details;
